import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';

const AboutPage = () => {
    return (
        <div className="about-page">
            <div className="about-container">
                {/* Header */}
                <header className="about-header">
                    <h1>About WineApp</h1>
                    <Link to="/welcome" className="back-to-app">← Back to App</Link>
                </header>

                {/* Main Content */}
                <div className="about-content">
                    {/* Who Am I Section */}
                    <section className="about-section">
                        <h2>Who Am I</h2>
                        <div className="section-content">
                            <p>
                            I'm <strong>Jason (Jay) Aspell</strong> — a wine-obsessed product/AI builder. 
                            I blend over a decade in data-driven change across financial services with 
                            hands-on machine learning. I hold WSET Level 3 and I'm studying for the WSET Diploma, with a 
                            simple goal: make choosing wine feel effortless, confident, and fun.
                            </p>
                        </div>
                    </section>

                    {/* Purpose Section */}
                    <section className="about-section">
                        <h2>Purpose of the App</h2>
                        <div className="section-content">
                            <p>
                                WineApp was created to bridge the gap between wine lovers and 
                                the perfect bottle for their dining experience. Whether you're dining 
                                out at your favorite restaurant or cooking at home, finding the right 
                                wine can be overwhelming.
                            </p>
                            <p>
                                Our AI-powered sommelier combines extensive wine databases with 
                                intelligent recommendations to help you:
                            </p>
                            <ul>
                                <li>Discover wines that perfectly match your food preferences</li>
                                <li>Explore restaurant wine lists with confidence</li>
                                <li>Learn about wine regions, appellations, and characteristics</li>
                                <li>Make informed decisions within your budget</li>
                                <li>Expand your wine knowledge through personalized suggestions</li>
                            </ul>
                            <p>
                                Every recommendation is tailored to your preferences, occasion, and 
                                budget, making wine selection accessible and enjoyable for everyone.
                            </p>
                        </div>
                    </section>

                    {/* Contact Section */}
                    <section className="about-section contact-section">
                        <h2>Get in Touch</h2>
                        <div className="contact-links">
                            <a 
                                href="mailto:jason.j.aspell@gmail.com" 
                                className="contact-link email-link"
                                aria-label="Send email"
                            >
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                </svg>
                                Email Me
                            </a>
                            
                            <a 
                                href="https://www.linkedin.com/in/jason-aspell/" 
                                className="contact-link linkedin-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn profile"
                            >
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                </svg>
                                LinkedIn
                            </a>
                        </div>
                    </section>
                </div>

                {/* Footer */}
                <footer className="about-footer">
                    <p>&copy; {new Date().getFullYear()} WineApp. Built with passion for wine and technology.</p>
                    <Link to="/welcome" className="footer-link">Return to your Wine Recommendations</Link>
                </footer>
            </div>
        </div>
    );
};

export default AboutPage;
